export const TARGET_STATUSES = {
  ABORTED: 'aborted',
  ACQUISITION: 'acquisition',
  CLOSED: 'closed',
  HOLD: 'hold',
  MASTERED: 'mastered',
  PROBE: 'probe',
  WAITING: 'waiting',
};

export const TARGET_DATA_TYPES = {
  CAB_BRANCH: 'cabBranch',
  DISCRETE_TRIAL: 'discreteTrial',
  DURATION: 'duration',
  INSTRUCTIONS: 'instructions',
  RANDOM_ROTATION: 'randomRotation',
  RATE: 'rate',
  SHAPING: 'shaping',
  TARGET_SET: 'targetSet',
  TASK_ANALYSIS: 'taskAnalysis',
};

export const TARGET_COLUMN_DEFS = [
  { value: 'label', labelKey: 'programs.targets.properties.label', sortable: true },
  { value: 'discriminativeStimulus', labelKey: 'programs.targets.properties.discriminativeStimulus', sortable: true },
  { value: 'status', labelKey: 'programs.targets.properties.status' },
  { value: 'introductionDate', labelKey: 'programs.targets.properties.introductionDate', sortable: true },
  { value: 'masteryDate', labelKey: 'programs.targets.properties.masteryDate', sortable: true },
  { value: 'trialsToAcquire', labelKey: 'programs.targets.properties.trialsToAcquire' },
  { value: 'sessionsToAcquire', labelKey: 'programs.targets.properties.sessionsToAcquire' },
];
